module.exports = __webpack_public_path__ + "img/1x.80e55a3.jpg";